const NoData = () => (
  <div className="composition-no-data">
    <span>No Data Available</span>
  </div>
);
export default NoData;
